import styles from './Approvers.module.css';

const ApproverAdd = () => {
  //TODO Need to add some on click behavior to add an approver
  return <div className={`${styles['approver']} ${styles['add']}`}>+</div>;
};

export default ApproverAdd;
